import UpgradeModal from "@components/common/premium/UpgradeModal";
import { DSBadge } from "@components/design-system/molecules";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { usePremiumFeature } from "@hooks";
import { Tooltip } from "@mui/material";
import mixpanel from "mixpanel-browser";
import { useState } from "react";

export const NoteQualityPill = ({ note }) => {
  const { hasFeatureAccess, UserPermissions } = usePremiumFeature();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const isFreePlanNote = note?.isFree;
  if (!isFreePlanNote) return null;

  const canUpgrade = !hasFeatureAccess(
    UserPermissions.PREMIUM_DEFAULT_NOTES_ENABLED,
  );

  return (
    <>
      <UpgradeModal
        shouldShow={showUpgradeModal}
        setShouldShow={setShowUpgradeModal}
        featureName="Advanced AI"
      />

      <Tooltip
        title="This note was generated using our standard AI model. If you have a pro plan, reprocess this note to use our advanced AI models for higher quality SOAP notes."
        arrow
      >
        <div
          className={canUpgrade ? "cursor-pointer" : "cursor-default"}
          onClick={() => {
            if (canUpgrade) {
              setShowUpgradeModal(true);
              mixpanel.track("Clicked Standard Quality Badge");
            }
          }}
        >
          <DSBadge
            variant="yellow"
            size="sm"
            icon={faInfoCircle}
            dataTestId="standard-quality-pill"
          >
            Standard Quality
          </DSBadge>
        </div>
      </Tooltip>
    </>
  );
};
